import axios from "axios";
import { useEffect, useState } from "react";
import { useMatch, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

// ===== Helpers de fecha =====
const parseISO = (s) => {
  if (!s) return null;
  const [y, m, d] = s.split("-").map(Number);
  return { y, m, d };
};
const fmtISO = (y, m, d) =>
  `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

/** Suma `months` meses y ajusta al último día del mes si hace falta (31→28/30, etc.) */
const addMonthsClamped = (isoDate, months) => {
  const p = parseISO(isoDate);
  if (!p) return "";
  const base = new Date(p.y, p.m - 1 + months, 1); // día 1 del mes destino
  const lastDay = new Date(base.getFullYear(), base.getMonth() + 1, 0).getDate();
  const day = Math.min(p.d, lastDay);
  return fmtISO(base.getFullYear(), base.getMonth() + 1, day);
};

// Para enviar la fecha como 00:00 UTC y evitar desfases por zona horaria
const toISODateUTC = (v) => (v ? new Date(`${v}T00:00:00.000Z`).toISOString() : undefined);

const RegistrarEProductiva = () => {
  const navigate = useNavigate();
  const { aprendizId, matriculaId } = useParams();

  // 🔹 Detectar rutas especiales
  const matchEditar = useMatch("/etapaproductiva/registro/editar/:epracticaId");
  const epracticaId = matchEditar?.params?.epracticaId;
  const matchBulk = useMatch("/etapaproductiva/registromasivo/:matriculaId");
  const isBulk = Boolean(matchBulk);

  // 🔹 Estados de aprendiz y matrícula
  const [aprendizObjectId, setAprendizObjectId] = useState("");
  const [documentoAprendiz] = useState("");
  const [matriculaObjectId, setMatriculaObjectId] = useState("");
  const [codMatricula] = useState("");

  // 🔹 Instructores y jefes
  const [instructorObjectId, setInstructorObjectId] = useState("");
  const [documentoInstructor, setDocumentoInstructor] = useState("");

  const [enteObjectId, setEnteObjectId] = useState("");
  const [nitEnteconformador, setNitEnteconformador] = useState("");

  const [jefeObjectId, setJefeObjectId] = useState("");
  const [documentoJefe, setDocumentoJefe] = useState("");

  // 🔹 Etapa práctica
  const [estadoEtapaPractica] = useState("");
  const [fechaInicioEtapaPractica, setFechaInicioEtapaPractica] = useState("");
  const [fechaFinEtapaPractica, setFechaFinEtapaPractica] = useState("");
  const [clasificacionEtapaPractica, setClasificacionEtapaPractica] = useState("publica");

  // ✅ Nombres alineados al backend
  const [alternativaEtapaPractica, setAlternativaEtapaPractica] = useState("");
  const [subtipoAlternativaEtapaPractica, setSubtipoAlternativaEtapaPractica] = useState("");

  // 🔹 ARL como STRINGS (no boolean)
  const [afiliadoARL, setAfiliadoARL] = useState("");            // "", "SI", "NO"
  const [nivelRiesgoARL, setNivelRiesgoARL] = useState("");      // "1".."5"
  const [riesgoCorrespondeARL, setRiesgoCorrespondeARL] = useState(""); // "", "SI", "NO"
  const [cuentaEPP, setCuentaEPP] = useState("");                // "", "SI", "NO", "NA"

  // Auxiliares UI (nombres, etc.)
  const [nombreEnte, setNombreEnte] = useState("");
  const [enteBloqueadoPorAsociacion, setEnteBloqueadoPorAsociacion] = useState(false);

  const [nombreJefe, setNombreJefe] = useState("");
  const [estadoAsignacion, setEstadoAsignacion] = useState("");
  const [mensajeAsociacion, setMensajeAsociacion] = useState("");
  const [telefono1Jefe, setTelefono1Jefe] = useState("");
  const [correoJefe, setCorreoJefe] = useState("");

  const [instructorNombre, setInstructorNombre] = useState("");
  const [instructorEmail, setInstructorEmail] = useState("");
  const [instructorId, setInstructorId] = useState("");

  

  // Modo edición
  const [edit, setEdit] = useState(false);
  useEffect(() => {
    setEdit(Boolean(epracticaId));
  }, [epracticaId]);

  // Prellenar ids desde la URL (CREACIÓN)
  useEffect(() => {
    // En masivo NO seteamos aprendiz desde la URL
    if (!isBulk && aprendizId && !edit) setAprendizObjectId(aprendizId);
  }, [aprendizId, edit, isBulk]);

  useEffect(() => {
    if (matriculaId && !edit) setMatriculaObjectId(matriculaId);
  }, [matriculaId, edit]);

  // ===== Alternativas =====
  const alternativas = {
    "Proyecto Productivo": [
      "Sena - Empresa",
      "Sena Proveedor Sena",
      "Producción de Centros",
      "Proyecto productivo I+D+i",
      "Proyectos Ruta Emprendedora SENA",
      "Prácticas en economía popular/campesina",
      "Convocatorias SENNOVA",
    ],
    "Monitoría": ["Monitoría regular", "Monitoría convocatorias SENNOVA", "Otra"],
    "Contrato Vínculo Formativo": [
      "Apoyo a una unidad productiva familiar",
      "De apoyo a institución estatal/ONG/sin ánimo de lucro",
      "Asesoría a pymes",
      "Prácticas en economía popular/campesina",
    ],
    "Contrato de Aprendizaje": [
      "Contrato de aprendizaje (regular)",
      "Convocatorias SENNOVA",
      "Prácticas en economía popular/campesina",
    ],
    "Vínculo Laboral": [
      "Vínculo laboral (regular)",
      "Prácticas en economía popular/campesina",
    ],
  };

  // Estados auxiliares para los selects (UI)
  const [alternativa, setAlternativa] = useState("");
  const [subtipo, setSubtipo] = useState("");

  const handleAlternativaChange = (e) => {
    const v = e.target.value;
    setAlternativa(v);                         // UI
    setSubtipo("");                            // UI
    setAlternativaEtapaPractica(v);            // backend
    setSubtipoAlternativaEtapaPractica("");    // backend
  };

  // ===== Fechas: inicio + 6 meses (auto) =====
  const handleInicioChange = (e) => {
    const v = e.target.value; // "YYYY-MM-DD"
    setFechaInicioEtapaPractica(v);
    setFechaFinEtapaPractica(v ? addMonthsClamped(v, 6) : "");
  };

  // En edición: si hay inicio y no hay fin, autocompletar una vez
  useEffect(() => {
    if (fechaInicioEtapaPractica && (!edit || !fechaFinEtapaPractica)) {
      setFechaFinEtapaPractica(addMonthsClamped(fechaInicioEtapaPractica, 6));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fechaInicioEtapaPractica, edit]);

  // ======= Clean =======
  const cleanData = () => {
    setClasificacionEtapaPractica("publica");

    setAlternativa("");
    setSubtipo("");
    setAlternativaEtapaPractica("");
    setSubtipoAlternativaEtapaPractica("");

    setNitEnteconformador("");
    setNombreEnte("");
    setEnteObjectId("");
    setEnteBloqueadoPorAsociacion(false);

    setDocumentoJefe("");
    setNombreJefe("");
    setEstadoAsignacion("");
    setMensajeAsociacion("");
    setTelefono1Jefe("");
    setCorreoJefe("");
    setJefeObjectId("");

    setDocumentoInstructor("");
    setInstructorNombre("");
    setInstructorEmail("");
    setInstructorId("");
    setInstructorObjectId("");

    setAfiliadoARL("");
    setNivelRiesgoARL("");
    setRiesgoCorrespondeARL("");
    setCuentaEPP("");

    setFechaInicioEtapaPractica("");
    setFechaFinEtapaPractica("");
  };

  // ======= Validación & Payload =======
  const validate = () => {
    const missing = [];

    // En masivo NO pedimos aprendiz
    if (!isBulk && !aprendizObjectId) missing.push("Aprendiz");
    if (!matriculaObjectId) missing.push("Matrícula");
    if (!clasificacionEtapaPractica) missing.push("Clasificación de la Etapa");
    if (!alternativaEtapaPractica) missing.push("Alternativa de Etapa Productiva");
    if (!afiliadoARL) missing.push("Afiliación ARL (SI/NO)");
    if (!riesgoCorrespondeARL) missing.push("¿Riesgo corresponde? (SI/NO)");
    if (!cuentaEPP) missing.push("¿Cuenta con EPP? (SI/NO/NA)");
    if (!documentoInstructor || isNaN(Number(documentoInstructor))) {
      missing.push("Documento del Instructor válido");
    }

    // rango fechas
    if (fechaInicioEtapaPractica && fechaFinEtapaPractica) {
      const ini = new Date(`${fechaInicioEtapaPractica}T00:00:00`);
      const fin = new Date(`${fechaFinEtapaPractica}T00:00:00`);
      if (fin < ini) {
        Swal.fire({
          icon: "warning",
          title: "Rango de fechas inválido",
          text: "La fecha de fin no puede ser anterior a la fecha de inicio.",
        });
        return false;
      }
    }

    if (missing.length) {
      Swal.fire({
        icon: "warning",
        title: "Faltan datos obligatorios",
        html: `<ul class="text-start mb-0">${missing.map(m => `<li>${m}</li>`).join("")}</ul>`,
      });
      return false;
    }

    if (!Object.keys(alternativas).includes(alternativaEtapaPractica)) {
      Swal.fire({ icon: "warning", title: "Alternativa inválida" });
      return false;
    }
    return true;
  };

  const toNumberOrUndef = (v) =>
    v !== "" && !Number.isNaN(Number(v)) ? Number(v) : undefined;

  // Payload individual
  const buildPayload = () => {
    const raw = {
      aprendizObjectId,                     // ObjectId (string)
      documentoAprendiz,                    // opcional
      matriculaObjectId,                    // ObjectId (string)
      codMatricula,

      enteObjectId,                         // ObjectId (string)
      nitEnteconformador,

      instructorObjectId,                   // ObjectId (string)
      documentoInstructor: toNumberOrUndef(documentoInstructor),

      jefeObjectId,                         // ObjectId (string)
      documentoJefe: toNumberOrUndef(documentoJefe),

      estadoEtapaPractica,

      // Fechas como ISO UTC
      fechaInicioEtapaPractica: toISODateUTC(fechaInicioEtapaPractica),
      fechaFinEtapaPractica: toISODateUTC(fechaFinEtapaPractica),

      clasificacionEtapaPractica,

      alternativaEtapaPractica,
      subtipoAlternativaEtapaPractica,

      afiliadoARL,                          // "SI"/"NO"
      nivelRiesgoARL: toNumberOrUndef(nivelRiesgoARL), // número
      riesgoCorrespondeARL,                 // "SI"/"NO"
      cuentaEPP,                            // "SI"/"NO"/"NA"
    };

    // Evita mandar strings vacíos (ObjectId/enums vacíos causan cast error)
    return Object.fromEntries(
      Object.entries(raw).filter(
        ([_, v]) => !(typeof v === "string" && v.trim() === "")
      )
    );
  };

  // 🔹 Payload MASIVO (sin aprendizObjectId/documentoAprendiz)
  const buildBulkPayload = () => {
    const raw = {
      enteObjectId,
      nitEnteconformador,

      instructorObjectId,
      documentoInstructor: toNumberOrUndef(documentoInstructor),

      jefeObjectId,
      documentoJefe: toNumberOrUndef(documentoJefe),

      estadoEtapaPractica,

      // Fechas para todos
      fechaInicioEtapaPractica: toISODateUTC(fechaInicioEtapaPractica),
      fechaFinEtapaPractica: toISODateUTC(fechaFinEtapaPractica),

      clasificacionEtapaPractica,
      alternativaEtapaPractica,
      subtipoAlternativaEtapaPractica,

      afiliadoARL,
      nivelRiesgoARL: toNumberOrUndef(nivelRiesgoARL),
      riesgoCorrespondeARL,
      cuentaEPP,

      // opciones del bulk
      soloActivos: true,
      dryRun: false,
    };

    return Object.fromEntries(
      Object.entries(raw).filter(
        ([_, v]) => !(typeof v === "string" && v.trim() === "")
      )
    );
  };

  // ======= API =======
  const saveEPractica = async () => {
    try {
      if (!validate()) return;

      await axios.post("/api/etapapractica/add", buildPayload());
      cleanData();

      await Swal.fire({
        icon: "success",
        title: "La Etapa de Práctica ha sido registrada con éxito",
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
      });

      navigate("/etapaproductiva/listareproductiva");
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text:
          error?.response?.data?.message ||
          "Ya existe una etapa práctica para este aprendiz y matrícula.",
        confirmButtonText: "Volver",
      });

      navigate(-1); // <- minúscula
    }
  };

  const updateEPractica = async () => {
    try {
      if (!validate()) return;
      if (!epracticaId) {
        return Swal.fire({
          icon: "warning",
          title: "ID de etapa no encontrado para actualizar",
        });
      }
      await axios.put(`/api/etapapractica/update/${epracticaId}`, buildPayload());
      cleanData?.();
      Swal.fire({
        icon: "success",
        title: "La Etapa de Práctica ha sido actualizada con éxito",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      alert(error.response?.data?.message || "Error al actualizar");
    }
  };

  // 🔹 Guardado MASIVO
  const saveEPracticaBulk = async () => {
    try {
      if (!validate()) return;

      const mid = matriculaId || matriculaObjectId;
      if (!mid) {
        return Swal.fire({
          icon: "warning",
          title: "Falta el ID de matrícula",
          text: "No se encontró el parámetro en la URL."
        });
      }

    await axios.post(`/api/etapapractica/bulk/${mid}`, buildBulkPayload());

      await Swal.fire({
        icon: "success",
        title: "Registro masivo completado",
        timer: 1500,
        showConfirmButton: false
      });


      navigate("/etapaproductiva/listareproductiva");
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error en el registro masivo",
        text: error?.response?.data?.message || "No fue posible crear la etapa productiva masiva."
      });
    }
  };


  const actions = (e) => {
    e.preventDefault();
    if (isBulk) {
      saveEPracticaBulk();
    } else {
      edit ? updateEPractica() : saveEPractica();
    }
  };

  // ======= Verificaciones externas =======
  const verificarNit = async (nit) => {
    if (!nit) return;
    try {
      const response = await axios.get(`/api/ente/verificar/${nit}`);
      if (response.data?.exists) {
        setNombreEnte(response.data.nombreEnteconformador || "");
        setEnteObjectId(response.data.enteId || response.data._id || "");
        setEnteBloqueadoPorAsociacion(false);
      } else {
        setNombreEnte("");
        setEnteObjectId("");
      }
    } catch (error) {
      console.error("Error al verificar el NIT:", error);
      setNombreEnte("");
      setEnteObjectId("");
    }
  };

  const verificarJefeActivo = async (doc) => {
    if (!doc) return;
    try {
      const { data } = await axios.get(
        `/api/asociarjefes/verificar/${encodeURIComponent(doc)}/Activo`
      );

      if (data?.ok && data.exists) {
        setDocumentoJefe(String(doc));
        setNombreJefe(data.nombreJefe || "");
        setEstadoAsignacion(data.estadoAsignacion || "Activo");
        setMensajeAsociacion("Asociación activa encontrada.");

        const jefeId =
          data.jefeObjectId?._id ||
          data.jefeObjectId ||
          data.asociacion?.jefeObjectId?._id ||
          data.asociacion?.jefeObjectId ||
          data.jefeId ||
          "";
        setJefeObjectId(jefeId || "");

        const tel =
          data.telefono1Jefe ||
          data.asociacion?.jefeObjectId?.telefono1Jefe ||
          "";
        const mail =
          data.correoJefe ||
          data.asociacion?.jefeObjectId?.correoJefe ||
          data.asociacion?.jefeObjectId?.emailJefe ||
          "";
        setTelefono1Jefe(tel);
        setCorreoJefe(mail);

        const enteNombre =
          data.enteConformador ||
          data.asociacion?.enteObjectId?.nombreEnteconformador ||
          "";
        const enteNit = data.asociacion?.enteObjectId?.nitEnteconformador || "";
        const enteId =
          data.asociacion?.enteObjectId?._id ||
          data.asociacion?.enteObjectId ||
          "";

        if (enteNombre) setNombreEnte(enteNombre);
        if (enteNit) setNitEnteconformador(enteNit);
        if (enteId) setEnteObjectId(enteId);

        if (enteNombre || enteNit) setEnteBloqueadoPorAsociacion(true);
      } else {
        setNombreJefe("");
        setEstadoAsignacion("");
        setMensajeAsociacion(data?.message || "El jefe no tiene asociación activa.");
        setTelefono1Jefe("");
        setCorreoJefe("");
        setJefeObjectId("");
        setEnteBloqueadoPorAsociacion(false);
      }
    } catch (error) {
      console.error("Error al verificar la asociación activa:", error);
      setNombreJefe("");
      setEstadoAsignacion("");
      setMensajeAsociacion("Error al verificar la asociación activa.");
      setTelefono1Jefe("");
      setCorreoJefe("");
      setJefeObjectId("");
      setEnteBloqueadoPorAsociacion(false);
    }
  };

  const verificarInstructor = async (doc) => {
    if (!doc) return;
    try {
      const { data } = await axios.get(
        `/api/instructores/verificar/${encodeURIComponent(doc)}`
      );

      if (data?.exists) {
        setDocumentoInstructor(String(doc));
        setInstructorNombre(data.nombreCompleto || "");
        setInstructorEmail(data.emailInstructor || "");

        const instId =
          data.instructorObjectId?._id ||
          data.instructorObjectId ||
          data.instructor?._id ||
          data.instructorId ||
          "";
        setInstructorId(instId || "");
        setInstructorObjectId(instId || "");
      } else {
        setInstructorNombre("");
        setInstructorEmail("");
        setInstructorId("");
        setInstructorObjectId("");
      }
    } catch (error) {
      console.error("Error al verificar el documento del instructor:", error);
      setInstructorNombre("");
      setInstructorEmail("");
      setInstructorId("");
      setInstructorObjectId("");
    }
  };

  // Handlers simples
  const handleDocInstructorChange = (e) => setDocumentoInstructor(e.target.value);

  // ===================== RENDER =====================
  return (
    <div className="container-fluid py-3 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5">
      <div className="container-fluid mt-3">
        <h1 className="fw-bold text-center">
          {isBulk ? "Registrar Etapa Práctica (Masivo por Matrícula)" : "Registrar Etapa Práctica"}
        </h1>
      </div>

      <form onSubmit={actions}>
        {/* Clasificación */}
        <div className="container my-3">
          <div className="btn-group w-100" role="group" aria-label="Clasificación del documento">
            <input
              type="radio"
              className="btn-check"
              name="clasificacion"
              id="opt-publica"
              autoComplete="off"
              value="publica"
              checked={clasificacionEtapaPractica === "publica"}
              onChange={(e) => setClasificacionEtapaPractica(e.target.value)}
            />
            <label className="btn btn-outline-success" htmlFor="opt-publica">Pública</label>

            <input
              type="radio"
              className="btn-check"
              name="clasificacion"
              id="opt-clasificada"
              autoComplete="off"
              value="clasificada"
              checked={clasificacionEtapaPractica === "clasificada"}
              onChange={(e) => setClasificacionEtapaPractica(e.target.value)}
            />
            <label className="btn btn-outline-primary" htmlFor="opt-clasificada">Pública Clasificada</label>

            <input
              type="radio"
              className="btn-check"
              name="clasificacion"
              id="opt-reservada"
              autoComplete="off"
              value="reservada"
              checked={clasificacionEtapaPractica === "reservada"}
              onChange={(e) => setClasificacionEtapaPractica(e.target.value)}
            />
            <label className="btn btn-outline-warning" htmlFor="opt-reservada">Pública Reservada</label>
          </div>
          <div className="small text-muted mt-2">
            Selección actual: <strong>{clasificacionEtapaPractica}</strong>
          </div>
        </div>

        {/* Periodo (una sola fila) */}
        <div className="container my-3">
          <div className="row g-3 align-items-end">
            <div className="col-12 col-md-3">
              <label className="form-label small">Fecha Inicio</label>
              <input
                type="date"
                className="form-control"
                value={fechaInicioEtapaPractica}
                onChange={handleInicioChange}
              />
            </div>

            <div className="col-12 col-md-3">
              <label className="form-label small">Fecha Fin (auto +6 meses)</label>
              <input
                type="date"
                className="form-control"
                value={fechaFinEtapaPractica}
                readOnly
                tabIndex={-1}
              />
            </div>
          </div>
        </div>

        <div className="container">
          {/* Nav Tabs */}
          <ul className="nav nav-tabs mt-3" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="nav-link active" id="EnteCoformador-tab" data-bs-toggle="tab" data-bs-target="#EnteCoformador" type="button" role="tab">
                Ente Coformador
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="InstructorAsignado-tab" data-bs-toggle="tab" data-bs-target="#InstructorAsignado" type="button" role="tab">
                Instructor Asignado
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="Alternativa-tab" data-bs-toggle="tab" data-bs-target="#Alternativa" type="button" role="tab">
                Alternativa
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="RiesgosLaborales-tab" data-bs-toggle="tab" data-bs-target="#RiesgosLaborales" type="button" role="tab">
                Riesgos Laborales
              </button>
            </li>
          </ul>
        </div>

        <div className="mb-5">
          <div className="container">
            <div className="tab-content p-3 border border-top-0 bg-white" id="myTabContent">
              {/* TAB 1: Ente Coformador */}
              <div className="tab-pane fade show active" id="EnteCoformador" role="tabpanel">
                <div className="card mb-3">
                  <div className="card-header fw-semibold">Entidad, período y coformador</div>
                  <div className="card-body row g-3">
                    {/* Documento Jefe + verificación de asociación activa */}
                    <div className="col-md-2">
                      <label className="form-label small">Documento Jefe</label>
                      <input
                        type="text"
                        className="form-control"
                        value={documentoJefe}
                        onChange={(e) => setDocumentoJefe(e.target.value)}
                        onKeyDown={(e) => { if (e.key === "Enter" || e.key === "Tab") verificarJefeActivo(e.target.value); }}
                        onBlur={(e) => verificarJefeActivo(e.target.value)}
                        placeholder="Ej: 12345678"
                      />
                    </div>
                    <div className="col-md-5">
                      <label className="form-label small">Nombre del Jefe</label>
                      <input
                        type="text"
                        className="form-control"
                        value={nombreJefe}
                        onChange={(e) => setNombreJefe(e.target.value)}
                        placeholder="Se autollenará si tiene asociación activa"
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label small">Teléfono Jefe</label>
                      <input
                        type="text"
                        className="form-control"
                        value={telefono1Jefe}
                        onChange={(e) => setTelefono1Jefe(e.target.value)}
                        placeholder="Teléfono del jefe"
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label small">Email Jefe</label>
                      <input
                        type="email"
                        className="form-control"
                        value={correoJefe}
                        onChange={(e) => setCorreoJefe(e.target.value)}
                        placeholder="correo@dominio.com"
                      />
                    </div>

                    {/* Estado de la asociación */}
                    <div className="col-12">
                      {mensajeAsociacion && (
                        <div className={`alert ${estadoAsignacion === "Activo" ? "alert-success" : "alert-warning"} py-2 mb-2`}>
                          <strong>{mensajeAsociacion}</strong>
                          {estadoAsignacion && (
                            <span className="ms-2 badge bg-dark">Estado: {estadoAsignacion}</span>
                          )}
                        </div>
                      )}
                    </div>

                    {/* NIT / Ente */}
                    <div className="col-md-2">
                      <label className="form-label small">
                        Nit Empresa {enteBloqueadoPorAsociacion && <span className="badge bg-secondary ms-1">Bloqueado</span>}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={nitEnteconformador}
                        onChange={(e) => setNitEnteconformador(e.target.value)}
                        onKeyDown={(e) => { if (e.key === "Enter" || e.key === "Tab") verificarNit(e.target.value); }}
                        onBlur={(e) => verificarNit(e.target.value)}
                        placeholder="Ej: 900123456"
                        disabled={enteBloqueadoPorAsociacion}
                      />
                    </div>
                    <div className="col-md-10">
                      <label className="form-label small">
                        Nombre de la empresa / Ente conformador / organización{" "}
                        {enteBloqueadoPorAsociacion && <span className="badge bg-secondary ms-1">Bloqueado</span>}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={nombreEnte}
                        onChange={(e) => setNombreEnte(e.target.value)}
                        disabled={enteBloqueadoPorAsociacion}
                      />
                      <input type="hidden" value={enteObjectId} readOnly />
                      {enteBloqueadoPorAsociacion && (
                        <div className="form-text">
                          El Ente proviene de la asociación activa del jefe. Para editarlo, cambia/elimina el jefe y vuelve a verificar.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* TAB 2: Instructor Asignado */}
              <div className="tab-pane fade" id="InstructorAsignado" role="tabpanel">
                <div className="card mb-3">
                  <div className="card-header fw-semibold">Datos del instructor asignado para el seguimiento</div>
                  <div className="card-body row g-3">
                    <div className="col-md-3">
                      <label className="form-label small">Documento Instructor</label>
                      <input
                        type="text"
                        className="form-control"
                        value={documentoInstructor}
                        onChange={handleDocInstructorChange}
                        onKeyDown={(e) => { if (e.key === "Enter" || e.key === "Tab") verificarInstructor(e.target.value); }}
                        onBlur={(e) => verificarInstructor(e.target.value)}
                        placeholder="Ej: 1077866875"
                      />
                      <input type="hidden" value={instructorId} readOnly />
                    </div>
                    <div className="col-md-5">
                      <label className="form-label small">Nombre Instructor</label>
                      <input
                        type="text"
                        className="form-control"
                        value={instructorNombre}
                        onChange={(e) => setInstructorNombre(e.target.value)}
                        placeholder="Nombre del instructor"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small">Email Instructor</label>
                      <input
                        type="email"
                        className="form-control"
                        value={instructorEmail}
                        onChange={(e) => setInstructorEmail(e.target.value)}
                        placeholder="correo@dominio.com"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* TAB 3: Alternativa */}
              <div className="tab-pane fade" id="Alternativa" role="tabpanel">
                <div className="card mb-3">
                  <div className="card-header fw-semibold">Seleccione la alternativa de etapa productiva y su subtipo</div>
                  <div className="card-body row g-3">
                    <div className="col-md-6">
                      <label className="form-label small">Alternativa de Etapa Productiva</label>
                      <select
                        className="form-select"
                        value={alternativa}
                        onChange={handleAlternativaChange}
                      >
                        <option value="">-- Seleccione --</option>
                        {Object.keys(alternativas).map((alt) => (
                          <option key={alt} value={alt}>{alt}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small">Subtipo de Alternativa</label>
                      <select
                        className="form-select"
                        value={subtipo}
                        onChange={(e) => {
                          setSubtipo(e.target.value);                         // UI
                          setSubtipoAlternativaEtapaPractica(e.target.value); // backend
                        }}
                        disabled={!alternativa}
                      >
                        <option value="">-- Seleccione --</option>
                        {alternativa &&
                          alternativas[alternativa].map((sub) => (
                            <option key={sub} value={sub}>{sub}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* TAB 4: Riesgos Laborales */}
              <div className="tab-pane fade" id="RiesgosLaborales" role="tabpanel">
                <div className="card mb-3">
                  <div className="card-header bg-dark text-white text-center fw-semibold">
                    Decreto 055 de 2015 - Riesgos Laborales
                  </div>
                  <div className="card-body">
                    <div className="alert alert-secondary text-center py-2 mb-3">
                      Este espacio debe ser siempre diligenciado.
                    </div>
                    <div className="small mb-3">
                      <p><strong>Artículo 11.</strong> Obligaciones de la institución de educación:</p>
                      <ol className="mb-0 ps-3">
                        <li>Revisar periódicamente que el estudiante en práctica desarrolle labores relacionadas exclusivamente con su programa de formación.</li>
                        <li>Verificar que el espacio de práctica cuente con los elementos de protección personal apropiados según el riesgo ocupacional.</li>
                      </ol>
                    </div>
                    <div className="row g-3">
                      <div className="col-12 col-md-6 col-lg-3">
                        <label className="form-label small fw-semibold">¿Se encuentra afiliado a la ARL?</label>
                        <select
                          className="form-select"
                          value={afiliadoARL}
                          onChange={(e) => setAfiliadoARL(e.target.value)}
                        >
                          <option value="">--</option>
                          <option value="SI">SI</option>
                          <option value="NO">NO</option>
                        </select>
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <label className="form-label small fw-semibold">Nivel de riesgo actual</label>
                        <select
                          className="form-select"
                          value={nivelRiesgoARL}
                          onChange={(e) => setNivelRiesgoARL(e.target.value)}
                        >
                          <option value="">--</option>
                          <option value="1">Nivel 1</option>
                          <option value="2">Nivel 2</option>
                          <option value="3">Nivel 3</option>
                          <option value="4">Nivel 4</option>
                          <option value="5">Nivel 5</option>
                        </select>
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <label className="form-label small fw-semibold">¿El nivel de riesgo de la ARL corresponde?</label>
                        <select
                          className="form-select"
                          value={riesgoCorrespondeARL}
                          onChange={(e) => setRiesgoCorrespondeARL(e.target.value)}
                        >
                          <option value="">--</option>
                          <option value="SI">SI</option>
                          <option value="NO">NO</option>
                        </select>
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <label className="form-label small fw-semibold">¿Cuenta con EPP?</label>
                        <select
                          className="form-select"
                          value={cuentaEPP}
                          onChange={(e) => setCuentaEPP(e.target.value)}
                        >
                          <option value="">--</option>
                          <option value="SI">SI</option>
                          <option value="NO">NO</option>
                          <option value="NA">NA</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* FIN TABS */}
            </div>
          </div>
        </div>

        {/* Botones de acción */}
        <div className="d-flex justify-content-end gap-2 mt-4 px-3">
          <button type="submit" className="btn btn-success">
            <i className="fa-solid fa-floppy-disk me-1"></i> {isBulk ? "Guardar Masivo" : (edit ? "Actualizar" : "Guardar")}
          </button>
          <button type="button" className="btn btn-secondary" onClick={cleanData}>
            <i className="fa-solid fa-eraser me-1"></i> Limpiar
          </button>
          <button type="button" className="btn btn-danger" onClick={() => navigate(-1)} >
            <i className="fa-solid fa-xmark me-1"></i> Cancelar
          </button>

        </div>
      </form>
    </div>
  );
};

export default RegistrarEProductiva;
